import {
  CaseReviewOverviewPanel,
  type CaseCheckingGrade,
} from "@/components/case-checking/CaseReviewOverviewPanel";
import { TimelineStoryPanel } from "@/components/case-checking/TimelineStoryPanel";
import type { CaseReview as ApiCaseReview, CaseTimeline } from "@/services/api/case-checking";

export function ReviewNarrativeStep({
  grade,
  caseReview,
  timeline,
  displayAdviser,
  fallbackAdviser,
}: {
  grade: CaseCheckingGrade;
  caseReview?: ApiCaseReview | null;
  timeline: CaseTimeline | null;
  displayAdviser?: string;
  fallbackAdviser?: string;
}) {
  return (
    <div className="space-y-3" data-testid="review-narrative-step">
      <CaseReviewOverviewPanel
        grade={grade}
        caseReview={caseReview ?? null}
        displayAdviser={displayAdviser}
        fallbackAdviser={fallbackAdviser}
        showHumanReview={false}
        showAgentReviewRouting
        gradeRationaleDefaultOpen
      />
      <TimelineStoryPanel timeline={timeline} />
    </div>
  );
}
